import { createTheme, responsiveFontSizes } from "@mui/material";
import merge from "lodash/merge";
import { THEMES } from "../constants";
import components from "./components";
import { shadows } from "./shadows";
import themesOptions from "./themeOptions";

const fontStack =
  "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";

const baseOptions = {
  direction: "ltr",
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: fontStack,
    fontWeightLight: 400,
    fontWeightRegular: 450,
    fontWeightMedium: 550,
    fontWeightBold: 650,
    h1: { fontWeight: 650, fontSize: "2.5rem", letterSpacing: "-0.028em", lineHeight: 1.12 },
    h2: { fontWeight: 650, fontSize: "1.875rem", letterSpacing: "-0.024em", lineHeight: 1.18 },
    h3: { fontWeight: 650, fontSize: "1.5rem", letterSpacing: "-0.02em", lineHeight: 1.25 },
    h4: { fontWeight: 600, fontSize: "1.1875rem", letterSpacing: "-0.015em", lineHeight: 1.3 },
    h5: { fontWeight: 600, fontSize: "0.9375rem", letterSpacing: "-0.011em", lineHeight: 1.4 },
    h6: { fontWeight: 600, fontSize: "0.8125rem", letterSpacing: "-0.005em", lineHeight: 1.45 },
    subtitle1: { fontWeight: 500, fontSize: "0.875rem", lineHeight: 1.5 },
    subtitle2: { fontWeight: 500, fontSize: "0.8125rem", lineHeight: 1.5 },
    body1: { fontSize: "0.875rem", lineHeight: 1.6 },
    body2: { fontSize: "0.8125rem", lineHeight: 1.55 },
    button: { fontWeight: 550, letterSpacing: "-0.005em", textTransform: "none" },
    caption: { fontSize: "0.75rem", lineHeight: 1.5 },
    overline: {
      fontWeight: 600,
      fontSize: "0.6875rem",
      letterSpacing: "0.06em",
      textTransform: "uppercase",
    },
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },
};

export type themeSettingsTypes = {
  activeLayout?: string;
  theme: string;
  direction: "ltr" | "rtl";
  responsiveFontSizes?: boolean;
};

export const createCustomTheme = (settings: themeSettingsTypes) => {
  let themeOptions: any = themesOptions[settings.theme];

  if (!themeOptions) {
    themeOptions = themesOptions[THEMES.LIGHT];
  }

  const mergedThemeOptions = merge({}, baseOptions, themeOptions, {
    direction: settings.direction,
  });

  let theme = createTheme(mergedThemeOptions);

  theme.shadows = shadows(theme);
  theme.components = components(theme);

  if (settings.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
